import styled from 'styled-components';

import { variable } from '../../helpers/style.helpers';

import { ChevronProps } from './Chevron.decl';

import { ChevronDownOutlined, ChevronUpOutlined, Icon } from '@aircall/tractor';

const StyledChevron = styled(Icon)<Omit<ChevronProps, 'direction'>>`
  display: flex;
  width: max-content;
  align-items: center;
  justify-content: center;
  padding: 0 ${variable.space.s}px 0 ${variable.space.xxs}px;
  cursor: ${({ cursor }) => cursor ?? 'default'};
`;

export function Chevron({ direction, ...props }: ChevronProps) {
  return (
    <StyledChevron
      {...props}
      component={direction === 'up' ? ChevronUpOutlined : ChevronDownOutlined}
    />
  );
}
